export default "__VITE_ASSET__DCKf_GJ6__"